import { PremiumReceivablesTransactionRecord } from "entities/UIModel/PremiumReceivablesTransactionRecord";
import { emptyPremiumReceivableRecord } from "./shared/premiumReceivableRecord";

// Sample data kept ONLY to keep the Ledger Report tab demo alive. The Premium
// Receivables tab no longer reads it — it loads live data via
// usePremiumReceivableList / PremiumReceivable/GetPremiumReceivableListByCriteria.
// Delete this file once the Ledger Report tab is wired to the API too.
//
// Field names mirror the PremiumReceivable entity; dates are ISO so they
// round-trip through the same formatDate() the live grid uses.
const row = (
  id: string,
  values: Partial<PremiumReceivablesTransactionRecord>
): PremiumReceivablesTransactionRecord => ({
  ...emptyPremiumReceivableRecord(id),
  ...values,
});

export const SAMPLE_TRANSACTION_RECORDS: PremiumReceivablesTransactionRecord[] = [
  row("PR-001", {
    PolicyNumber: "O-9840-0012345",
    AgentID: "54321",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-18T00:00:00",
    PolicyDate: "2026-03-15T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "TX",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 425000,
    ActualFee: 2847.5,
    ActualRemittance: 1423.75,
    IsAccrual: false,
    Comments: "Auto-generated on close",
  }),
  row("PR-002", {
    PolicyNumber: "M-9840-0012399",
    AgentID: "54321",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-19T00:00:00",
    PolicyDate: "2026-03-18T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "TX",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 2500000,
    ActualFee: 4250.0,
    ActualRemittance: 2125.0,
    IsAccrual: false,
  }),
  row("PR-003", {
    PolicyNumber: "O-7620-0098765",
    AgentID: "99887",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-20T00:00:00",
    PolicyDate: "2026-03-20T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "CA",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 1200000,
    ActualFee: 5100.0,
    ActualRemittance: 2550.0,
    IsAccrual: false,
  }),
  row("PR-004", {
    PolicyNumber: "E-5510-0045678",
    AgentID: "12345",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-21T00:00:00",
    PolicyDate: "2026-03-21T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "FL",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 350000,
    ActualFee: 275.0,
    ActualRemittance: 137.5,
    IsAccrual: false,
  }),
  row("PR-005", {
    PolicyNumber: "C-3320-0011223",
    AgentID: "67890",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-22T00:00:00",
    PolicyDate: "2026-03-22T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "NY",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 875000,
    ActualFee: 3250.0,
    ActualRemittance: 1625.0,
    IsAccrual: false,
  }),
  row("PR-006", {
    AgentID: "54321",
    AccountingPeriod: "202604",
    ReceivedDate: "2026-04-01T00:00:00",
    StateAbbr: "TX",
    PremiumReceivableTypeCode: "ADJ",
    PolicyCount: 0,
    LiabilityAmount: 0,
    ActualFee: -500.0,
    ActualRemittance: -250.0,
    IsAccrual: true,
    Comments: "Accrual adjustment for Q1",
  }),
  row("PR-007", {
    PolicyNumber: "G-2200-0077889",
    AgentID: "54321",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-24T00:00:00",
    PolicyDate: "2026-03-24T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "TX",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 180000,
    ActualFee: 450.0,
    ActualRemittance: 225.0,
    IsAccrual: false,
  }),
  row("PR-008", {
    PolicyNumber: "M-8810-0034567",
    AgentID: "12345",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-12T00:00:00",
    PolicyDate: "2026-03-12T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "FL",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 550000,
    ActualFee: 1500.0,
    ActualRemittance: 750.0,
    IsAccrual: false,
  }),
  row("PR-009", {
    AgentID: "67890",
    AccountingPeriod: "202604",
    ReceivedDate: "2026-04-02T00:00:00",
    StateAbbr: "NY",
    PremiumReceivableTypeCode: "ADJ",
    PolicyCount: 0,
    LiabilityAmount: 0,
    ActualFee: 1200.0,
    ActualRemittance: 600.0,
    IsAccrual: true,
    Comments: "Accrual entry for pending policies",
  }),
  row("PR-010", {
    PolicyNumber: "L-6640-0022334",
    AgentID: "99887",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-05T00:00:00",
    PolicyDate: "2026-03-05T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "CA",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 625000,
    ActualFee: 150.0,
    ActualRemittance: 75.0,
    IsAccrual: false,
  }),
  row("PR-011", {
    PolicyNumber: "O-4410-0056789",
    AgentID: "11223",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-25T00:00:00",
    PolicyDate: "2026-03-25T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "MA",
    PremiumReceivableTypeCode: "REG",
    PolicyCount: 1,
    LiabilityAmount: 710000,
    ActualFee: 2800.0,
    ActualRemittance: 1400.0,
    IsAccrual: false,
  }),
  row("PR-012", {
    PolicyNumber: "O-9840-0099001",
    AgentID: "67890",
    AccountingPeriod: "202603",
    ReceivedDate: "2026-03-23T00:00:00",
    PolicyDate: "2026-03-23T00:00:00",
    PolicyYearMonth: "202603",
    StateAbbr: "NY",
    PremiumReceivableTypeCode: "WO",
    PolicyCount: 1,
    LiabilityAmount: 550000,
    ActualFee: 0,
    ActualRemittance: 0,
    IsAccrual: false,
    Comments: "Write-off — original policy reference missing",
  }),
];
